import { ReactComponent as BrandKitIconActive } from 'assets/icons/magic_pen_gradient.svg';
import { ReactComponent as QRCodeIcon } from 'assets/icons/qr_code.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload_cloud.svg';
import { ReactComponent as ChartIcon } from 'assets/icons/widgetmenu_charts.svg';
import { ReactComponent as IconsIcon } from 'assets/icons/widgetmenu_icons.svg';
import { ReactComponent as MapsIcon } from 'assets/icons/widgetmenu_maps.svg';
import { ReactComponent as PhotosIcon } from 'assets/icons/widgetmenu_photos.svg';
import { ReactComponent as ShapeIcon } from 'assets/icons/widgetmenu_shapes.svg';
// import { ReactComponent as ElementsIcon } from 'assets/icons/widgetmenu_elements.svg';
import { ReactComponent as TemplatesIcon } from 'assets/icons/widgetmenu_templates.svg';
import { ReactComponent as TextIcon } from 'assets/icons/widgetmenu_text.svg';
import { UserTypes } from 'modules/User';
import { WIDGET_MENU_OPTIONS } from 'types/WidgetMenu.types';

import { SidebarItem } from './WidgetMenu.types';

export const SIDEBAR_WIDTH = 80;
export const SIDE_MENU_WIDTH = 352;

export const SIDEMENU_CLOSE_BTN_ID = 'sidemenu-close-btn';

export const SIDEBAR_ITEMS: SidebarItem[] = [
  {
    label: 'Brand Kit',
    id: WIDGET_MENU_OPTIONS.BRAND_KIT,
    icon: BrandKitIconActive,
    disabledUserTypes: [UserTypes.Education],
  },
  { label: 'Templates', id: WIDGET_MENU_OPTIONS.TEMPLATES, icon: TemplatesIcon },
  { label: 'Text', id: WIDGET_MENU_OPTIONS.TEXT, icon: TextIcon },
  { label: 'Shapes', id: WIDGET_MENU_OPTIONS.SHAPES, icon: ShapeIcon },
  { label: 'Icons', id: WIDGET_MENU_OPTIONS.ICONS, icon: IconsIcon },
  { label: 'Photos', id: WIDGET_MENU_OPTIONS.PHOTOS, icon: PhotosIcon },
  { label: 'Uploads', id: WIDGET_MENU_OPTIONS.UPLOAD, icon: UploadIcon },
  { label: 'Images', id: WIDGET_MENU_OPTIONS.IMAGES, icon: PhotosIcon },
  { label: 'Charts', id: WIDGET_MENU_OPTIONS.CHARTS, icon: ChartIcon },
  { label: 'Maps', id: WIDGET_MENU_OPTIONS.MAPS, icon: MapsIcon },
  { label: 'QR Code', id: WIDGET_MENU_OPTIONS.QR_CODE, icon: QRCodeIcon },
  // TODO: remove this comment when elements are ready to be added back
  // { label: 'Elements', id: WIDGET_MENU_OPTIONS.ELEMENTS, icon: ElementsIcon },
];
